import type { Quote } from "../types";

export const filterCovers = (quote: Quote) =>
  quote.vertical === "workers_compensation"
    ? quote.covers.filter(
        cover =>
          cover.displayName !== "Employer's Liability" &&
          cover.displayName !== "Other States Coverage",
      )
    : quote.covers;
